import React from 'react';
import { CtaButton } from './CtaButton';
import { ImageSlot } from './ImageSlot';
import { cta, hero, productImages } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-night" data-id="element-103" data-mp="9ktetq07k6yt">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #f7f2e8 1px, transparent 1px), linear-gradient(to bottom, #f7f2e8 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-104" data-mp="9l32h6xs621c" />

      <div className="relative mx-auto grid max-w-content items-center gap-x-14 gap-y-7 px-5 pb-12 pt-8 sm:px-6 lg:grid-cols-[1fr_1fr] lg:pb-20 lg:pt-16" data-id="element-105" data-mp="sb1c3rh88373">
        <div className="text-center lg:col-start-1 lg:row-start-1 lg:self-end lg:text-left" data-id="element-106" data-mp="nbyid36p5jef">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-soft sm:text-sm" data-id="element-107" data-mp="3d33cssqt6ji4">
            {hero.eyebrow}
          </p>

          <h1 className="mx-auto mt-4 max-w-xl font-display text-[2rem] font-semibold leading-[1.12] tracking-tight text-parchment sm:text-5xl lg:mx-0 lg:text-[3.25rem]" data-id="element-108" data-mp="3j7zgtn69y0is">
            Encuentra <span className="text-gold-soft" data-id="element-109" data-mp="39acx8ne15ksh">en segundos</span> el versículo que tu
            corazón necesita hoy
          </h1>

          <div className="mt-5 flex items-center justify-center gap-3 lg:justify-start" data-id="element-110" data-mp="3e8mqutk3wdbz">
            <span aria-hidden="true" className="h-px w-8 bg-gold-soft/50" data-id="element-111" data-mp="30hrgtdxvfq6t" />
            <p className="font-display text-base font-semibold uppercase tracking-[0.2em] text-gold-soft sm:text-lg" data-id="element-112" data-mp="358rdci32w68s">
              {hero.productName}
            </p>
            <span aria-hidden="true" className="h-px w-8 bg-gold-soft/50 lg:hidden" data-id="element-113" data-mp="2qloea6z3xpjc" />
          </div>

          <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg lg:mx-0" data-id="element-114" data-mp="2vj7wfhyxemgk">
            {hero.subtitle}
          </p>
        </div>

        <ImageSlot src={productImages.hero} alt={productImages.heroAlt} label="Mockup principal del Botiquín Espiritual" className="mx-auto w-full max-w-md overflow-hidden rounded-2xl shadow-[0_24px_60px_rgba(0,0,0,0.5)] lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-none" data-id="element-115" data-mp="2ljgzzaqt1xdu" />

        <div className="mx-auto w-full max-w-md text-center lg:col-start-1 lg:row-start-2 lg:mx-0 lg:self-start lg:text-left" data-id="element-116" data-mp="ia5fingpvzpf">
          <CtaButton size="block" href="#oferta" data-id="element-117" data-mp="1b0nizplcs33d">
            {cta.label}
          </CtaButton>
          <p className="mt-3 font-sans text-xs leading-relaxed text-parchment/55 sm:text-[0.8rem]" data-id="element-118" data-mp="1622jjsdxdnfz">
            {cta.heroMicro}
          </p>
        </div>
      </div>
    </header>;
}